import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const Brochure = () => {
  const handleDownloadBrochure1 = () => {
    const link = document.createElement('a');
    link.href = '/assets/brochure1.jpeg';
    link.download = 'Conference_Brochure_Page_1.jpeg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadBrochure2 = () => {
    const link = document.createElement('a');
    link.href = '/assets/brochure2.jpeg';
    link.download = 'Conference_Brochure_Page_2.jpeg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Conference Brochures
          </Typography>
          
          <Typography variant="subtitle1" paragraph align="center" color="text.secondary" sx={{ mb: 4 }}>
            Click on the images or download buttons to save the brochures
          </Typography>

          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', lg: 'row' },
            gap: 6,
            justifyContent: 'center',
            alignItems: 'flex-start',
            mt: 4
          }}>
            <Box sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: { xs: '100%', lg: '600px' }
            }}>
              <Box sx={{ 
                position: 'relative',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                }
              }}>
                <img
                  src="/assets/brochure1.jpeg"
                  alt="Conference Brochure 1"
                  onClick={handleDownloadBrochure1}
                  style={{ 
                    width: '100%',
                    maxWidth: '550px',
                    height: 'auto', 
                    borderRadius: '12px',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                    marginBottom: '20px',
                    cursor: 'pointer'
                  }}
                />
              </Box>
              <Typography variant="h6" gutterBottom color="text.secondary">
                Brochure Page 1
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadBrochure1}
                sx={{
                  mt: 2,
                  px: 3,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 'bold'
                }}
              >
                Download Page 1
              </Button>
            </Box>

            <Box sx={{ 
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: { xs: '100%', lg: '600px' }
            }}>
              <Box sx={{ 
                position: 'relative',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.02)',
                }
              }}>
                <img
                  src="/assets/brochure2.jpeg"
                  alt="Conference Brochure 2"
                  onClick={handleDownloadBrochure2}
                  style={{ 
                    width: '100%',
                    maxWidth: '550px',
                    height: 'auto', 
                    borderRadius: '12px',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                    marginBottom: '20px',
                    cursor: 'pointer'
                  }}
                />
              </Box>
              <Typography variant="h6" gutterBottom color="text.secondary">
                Brochure Page 2
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadBrochure2}
                sx={{
                  mt: 2,
                  px: 3,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 'bold'
                }}
              >
                Download Page 2
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Brochure; 